/**
 * Identity
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ValidateCaptchaRequest { 
    smartToken?: string | null;
    captchaOutput?: string | null;
    lotNumber?: string | null;
    passToken?: string | null;
    genTime?: string | null;
}

